export const WIDGETS_REGISTRY = {
  CONTENT: "content-widgets",
  FOOTER: "footer-widgets",
  HERO: "hero-widgets",
  "LAYOUT-WIDGET": "layout-widgets",
};
